require.register("modules/m02s/m02s-activity/page-29/page-29", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page29 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page29;

  
});

